import { render, staticRenderFns } from "./GruposTeacher.vue?vue&type=template&id=cbcd22e0&scoped=true"
import script from "./GruposTeacher.vue?vue&type=script&lang=js"
export * from "./GruposTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcd22e0",
  null
  
)

export default component.exports